// extracted by mini-css-extract-plugin
export default {"noOutline":"hX0LRG"};